import * as React from "react";
const SvgLeftVector = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 8 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: {
  transform: "scaleX(-1)"
}, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.99219 9.63892L6.29174 5.63892L1.99219 1.63892", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgLeftVector;
